import React, { Component } from "react";
import "./style.css";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { product } from "../../../models";
import isArray from "../../../function/isArray";

class Matching extends Component {
  handleClick = value => {
    // actions
    const { setActiveOption } = this.props;
    // reducers
    const { ui } = this.props;
    const index = ui.options.findIndex(data => data.optionId === value);
    setActiveOption(value, index);
  };

  render() {
    const { ui, activeOptionId } = this.props;
    return (
      <div className="matching-wrap">
        <p className="subtitle">
          <Translation>{t => t("rightIndex.matching")}</Translation>
        </p>
        <div className="selection-wrap">
          {isArray(ui.t100Options) &&
            ui.t100Options.map((data, index) => (
              <div
                key={index}
                className={`blockBtn border-grey smaller ${
                  data.optionId === activeOptionId ? "select" : ""
                }`}
                onClick={() => this.handleClick(data.optionId)}
              >
                {data.displayText}
              </div>
            ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ui: state.product.ui,
    activeOptionIndex: state.product.activeOptionIndex,
    activeOptionId: state.product.activeOptionId
  };
};

const mapDispatchToProps = () => {
  return {
    setActiveOption: (id, index) => product.actions.setActiveOption(id, index)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Matching);
